import { useAppSelector } from 'redux/hooks';
import { MetaDataSelector } from 'redux/features/jobList';
import { DisplayJobCount } from 'components/DisplayJobCount';
import { CardNavigationPanel } from 'components/CardNavigationPanel';
import styles from '../screens/MatchJobListScreen/index.module.scss';

/** 求人件数・ナビゲーションパネル */
export const ListControls = () => {
  const jobListMeta = useAppSelector(MetaDataSelector);
  const totalCount = jobListMeta?.totalCount ?? 0;
  const resultCount = jobListMeta?.resultCount ?? 0;
  const offset = jobListMeta?.offset ?? 0;
  const limit = jobListMeta?.limit ?? 50;
  // 次のページが存在するかどうか
  const hasNextPage = offset + limit < totalCount;

  return (
    <div className={styles['matchJobList-listControls']}>
      <DisplayJobCount
        totalCount={totalCount}
        resultCount={resultCount}
        offset={offset}
      />
      <CardNavigationPanel hasNextPage={hasNextPage} />
    </div>
  );
};
